import { render, staticRenderFns } from "./Importations.vue?vue&type=template&id=09aa84b9&scoped=true"
import script from "./Importations.js?vue&type=script&lang=js&external"
export * from "./Importations.js?vue&type=script&lang=js&external"
import style0 from "./Importations.vue?vue&type=style&index=0&id=09aa84b9&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09aa84b9",
  null
  
)

export default component.exports